import BlueButton from 'client/components/core/BlueButton'
import React from 'react'
import { Trans } from 'react-i18next'
import { PopupEditButtonUi } from './popup-edit-button-ui'

interface PopupEditButtonProps {
  clickHandler: () => void
}

export const PopupEditButton = ({ clickHandler }: PopupEditButtonProps) => (
  <PopupEditButtonUi>
    <BlueButton onClick={clickHandler}>
      <span className="fas fa-cog" />
      {'  '}
      <Trans parent="span">entities.popup.edit_button_label</Trans>
    </BlueButton>
  </PopupEditButtonUi>
)
